import { render, staticRenderFns } from "./SkyDivingQuestionnaireCN.vue?vue&type=template&id=05bb52de"
import script from "./SkyDivingQuestionnaireCN.vue?vue&type=script&lang=js"
export * from "./SkyDivingQuestionnaireCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports